import PropTypes from 'prop-types';
import { service, factories, models } from 'powerbi-client';

export const POWERBI_SERVICE = new service.Service(
    factories.hpmFactory,
    factories.wpmpFactory,
    factories.routerFactory
);

export const TOKEN_REFRESH_MARGIN_MS = 5 * 60 * 1000;
export const PANE_ENABLE_DELAY_MS = 1000;
export const EMBED_TIMEOUT_MS = 40000;

export const EMBED_STATUS = {
    REQUESTING: 'requesting',
    RENDERING: 'rendering',
    RENDERED: 'rendered',
    ERROR: 'error',
};

const NUMERIC_DATA_TYPES = ['int', 'bigint', 'number', 'numeric', 'decimal', 'float', 'double'];

const coerceFilterValue = (value, dataType) => {
    if (NUMERIC_DATA_TYPES.includes((dataType || '').toLowerCase())) return Number(value);
    return value;
};

export const buildPowerBiFilters = (filterDefs) => {
    if (!filterDefs?.length) return [];

    return filterDefs.map((filterDef) => ({
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
            table: filterDef.table,
            column: filterDef.column,
        },
        operator: 'In',
        values: filterDef.values.map((value) => coerceFilterValue(value, filterDef.dataType)),
        filterType: models.FilterType.Basic,
        displaySettings: {
            isHiddenInViewMode: true,
            isLockedInViewMode: true,
        },
    }));
};

export const DASHBOARD_FILTER_SHAPE = PropTypes.shape({
    table: PropTypes.string.isRequired,
    column: PropTypes.string.isRequired,
    dataType: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export const DASHBOARD_SHAPE = PropTypes.shape({
    reportId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(DASHBOARD_FILTER_SHAPE),
});

export const DASHBOARD_SELECT_STYLES = {
    container: (base) => ({ ...base, flex: 1, minWidth: 0 }),
    control: (base) => ({
        ...base,
        minHeight: '34px',
        fontSize: '12px',
        borderColor: 'rgba(255,255,255,0.12)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderRadius: '4px',
        boxShadow: 'none',
        flexWrap: 'nowrap',
        '&:hover': { borderColor: 'rgba(255,255,255,0.25)' }
    }),
    singleValue: (base) => ({ ...base, color: 'white', fontSize: '12px' }),
    placeholder: (base) => ({ ...base, color: 'rgba(255,255,255,0.5)', fontSize: '12px' }),
    input: (base) => ({ ...base, color: 'white', fontSize: '12px' }),
    menu: (base) => ({ ...base, zIndex: 9999, backgroundColor: '#1e163c', border: '1px solid rgba(255,255,255,0.12)', minWidth: '200px' }),
    option: (base, state) => ({
        ...base,
        fontSize: '12px',
        padding: '6px 10px',
        backgroundColor: state.isSelected ? '#CB2C84' : state.isFocused ? 'rgba(0,93,229,0.1)' : 'transparent',
        color: 'white',
        '&:active': { backgroundColor: 'rgba(0,93,229,0.2)' }
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: '4px', color: 'rgba(255,255,255,0.5)' }),
};
